import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "table"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src", "onMousemove", "onMouseout"];
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_vxe_colgroup = _resolveComponent("vxe-colgroup");
  const _component_vxe_input = _resolveComponent("vxe-input");
  const _component_vxe_checkbox = _resolveComponent("vxe-checkbox");
  const _component_vxe_switch = _resolveComponent("vxe-switch");
  const _component_vxe_option = _resolveComponent("vxe-option");
  const _component_vxe_select = _resolveComponent("vxe-select");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_BatchEdit = _resolveComponent("BatchEdit");
  const _directive_allow = _resolveDirective("allow");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_vxe_table, {
    ref: "getDom",
    class: "my-table",
    border: "",
    resizable: "",
    height: "600",
    "scroll-x": {
      enabled: false
    },
    "row-config": {
      isHover: true
    },
    "scroll-y": {
      enabled: false
    },
    data: _ctx.data.list,
    "edit-rules": _ctx.validRules,
    onCheckboxChange: _ctx.getSelectRow,
    onCheckboxAll: _ctx.getSelectRow,
    "edit-config": {
      trigger: 'click',
      mode: 'cell',
      showStatus: true
    },
    "row-class-name": _ctx.rowClassName,
    "column-config": {
      resizable: true
    }
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.listHeader, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index + _ctx.data.headerIndex
      }, [item.type == 'checkbox' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 0,
        type: item.type,
        fixed: item.fixed,
        align: item.align,
        width: item.width
      }, null, 8, ["type", "fixed", "align", "width"])) : _createCommentVNode("", true), item.type == 'group' ? (_openBlock(), _createBlock(_component_vxe_colgroup, {
        key: 1,
        fixed: item.fixed,
        align: item.align,
        title: item.title
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (itemChild, indexChild) => {
          return _openBlock(), _createElementBlock("div", {
            key: indexChild + _ctx.data.headerIndex
          }, [itemChild.type == 'col' ? (_openBlock(), _createBlock(_component_vxe_column, {
            key: 0,
            field: itemChild.field,
            title: itemChild.title,
            width: itemChild.width,
            align: itemChild.align
          }, null, 8, ["field", "title", "width", "align"])) : _createCommentVNode("", true), itemChild.type == 'sel' ? (_openBlock(), _createBlock(_component_vxe_column, {
            key: 1,
            field: itemChild.field,
            title: itemChild.title,
            width: itemChild.width,
            align: itemChild.align,
            "edit-render": {
              name: 'select'
            }
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.getShowMh(scope.row[itemChild.field], itemChild.list[scope.$rowIndex], scope.$rowIndex)), 1)]),
            edit: _withCtx(scope => [_createVNode(_component_el_select, {
              modelValue: scope.row[itemChild.field],
              "onUpdate:modelValue": $event => scope.row[itemChild.field] = $event,
              filterable: "",
              remote: "",
              "reserve-keyword": "",
              clearable: "",
              "remote-method": query => {
                _ctx.getlist(query, scope.$rowIndex, scope);
              },
              "popper-append-to-body": false,
              placeholder: "可搜索"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemChild.list[scope.$rowIndex], (it, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: it.value,
                  value: it.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "remote-method"])]),
            _: 2
          }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true)]);
        }), 128))]),
        _: 2
      }, 1032, ["fixed", "align", "title"])) : _createCommentVNode("", true), item.type == 'group-allow' ? _withDirectives((_openBlock(), _createBlock(_component_vxe_colgroup, {
        key: 2,
        fixed: item.fixed,
        align: item.align,
        title: item.title
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (itemChild, indexChild) => {
          return _openBlock(), _createElementBlock("div", {
            key: indexChild + _ctx.data.headerIndex
          }, [itemChild.type == 'col' ? (_openBlock(), _createBlock(_component_vxe_column, {
            key: 0,
            field: itemChild.field,
            title: itemChild.title,
            width: itemChild.width,
            align: itemChild.align
          }, null, 8, ["field", "title", "width", "align"])) : _createCommentVNode("", true), itemChild.type == 'sel' ? (_openBlock(), _createBlock(_component_vxe_column, {
            key: 1,
            field: itemChild.field,
            title: itemChild.title,
            width: itemChild.width,
            align: itemChild.align,
            "edit-render": {
              name: 'select'
            }
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.getShowMh(scope.row[itemChild.field], itemChild.list[scope.$rowIndex], scope.$rowIndex)), 1)]),
            edit: _withCtx(scope => [_createVNode(_component_el_select, {
              modelValue: scope.row[itemChild.field],
              "onUpdate:modelValue": $event => scope.row[itemChild.field] = $event,
              filterable: "",
              remote: "",
              "reserve-keyword": "",
              "remote-method": query => {
                _ctx.getlist(query, scope.$rowIndex, scope);
              },
              "popper-append-to-body": false,
              placeholder: "可搜索"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemChild.list[scope.$rowIndex], (it, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: it.value,
                  value: it.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "remote-method"])]),
            _: 2
          }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true)]);
        }), 128))]),
        _: 2
      }, 1032, ["fixed", "align", "title"])), [[_directive_allow, 'NewCost.NewCostFinance']]) : _createCommentVNode("", true), item.type == 'group_1' ? (_openBlock(), _createBlock(_component_vxe_colgroup, {
        key: 3,
        fixed: item.fixed,
        align: item.align,
        title: item.title
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (itemChild, indexChild) => {
          return _openBlock(), _createElementBlock("div", {
            key: indexChild + _ctx.data.headerIndex
          }, [itemChild.type == 'col' ? (_openBlock(), _createBlock(_component_vxe_column, {
            key: 0,
            field: itemChild.field,
            title: itemChild.title,
            width: itemChild.width,
            align: itemChild.align
          }, null, 8, ["field", "title", "width", "align"])) : _createCommentVNode("", true), itemChild.type == 'img' ? (_openBlock(), _createBlock(_component_vxe_column, {
            key: 1,
            field: itemChild.field,
            title: itemChild.title,
            width: itemChild.width,
            align: itemChild.align
          }, {
            default: _withCtx(scope => [_createElementVNode("img", {
              src: scope.row.cover ? scope.row.cover : _ctx.defaulImg,
              class: "avatar",
              onError: _cache[0] || (_cache[0] = e => {
                e.target.src = _ctx.defaulImg;
              })
            }, null, 40, _hoisted_2)]),
            _: 2
          }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true)]);
        }), 128))]),
        _: 2
      }, 1032, ["fixed", "align", "title"])) : _createCommentVNode("", true), item.type == 'group_2' ? (_openBlock(), _createBlock(_component_vxe_colgroup, {
        key: 4,
        fixed: item.fixed,
        align: item.align,
        title: item.title
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (itemChild, indexChild) => {
          return _openBlock(), _createElementBlock("div", {
            key: indexChild + _ctx.data.headerIndex
          }, [itemChild.type == 'col' ? (_openBlock(), _createBlock(_component_vxe_column, {
            key: 0,
            field: itemChild.field,
            title: itemChild.title,
            width: itemChild.width,
            align: itemChild.align
          }, null, 8, ["field", "title", "width", "align"])) : _createCommentVNode("", true), itemChild.type == 'sel' ? (_openBlock(), _createBlock(_component_vxe_column, {
            key: 1,
            field: itemChild.field,
            title: itemChild.title,
            width: itemChild.width,
            align: itemChild.align,
            "edit-render": {
              name: 'select'
            }
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.getShowMh(scope.row[itemChild.field], itemChild.list[scope.$rowIndex], scope.$rowIndex)), 1)]),
            edit: _withCtx(scope => [_createVNode(_component_el_select, {
              modelValue: scope.row[itemChild.field],
              "onUpdate:modelValue": $event => scope.row[itemChild.field] = $event,
              filterable: "",
              remote: "",
              "reserve-keyword": "",
              "remote-method": query => {
                _ctx.getlist(query, scope.$rowIndex, scope);
              },
              "popper-append-to-body": false,
              placeholder: "可搜索"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemChild.list[scope.$rowIndex], (it, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: it.value,
                  value: it.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "remote-method"])]),
            _: 2
          }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true)]);
        }), 128))]),
        _: 2
      }, 1032, ["fixed", "align", "title"])) : _createCommentVNode("", true), item.type == 'col' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 5,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align
      }, null, 8, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'col_1' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 6,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align
      }, null, 8, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'colfd' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 7,
        fixed: item.fixed,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align
      }, null, 8, ["fixed", "field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'colfdedit' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 8,
        fixed: item.fixed,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(scope => [_createVNode(_component_vxe_input, {
          modelValue: scope.row[item.field],
          "onUpdate:modelValue": $event => scope.row[item.field] = $event,
          modelModifiers: {
            trim: true
          },
          type: "text",
          onBlur: $event => _ctx.clearNull(scope.row[item.field], scope.$rowIndex, item.field),
          onChange: $event => _ctx.getDom.updateStatus(scope)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onChange"])]),
        _: 2
      }, 1032, ["fixed", "field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'colfdedit-allow' ? _withDirectives((_openBlock(), _createBlock(_component_vxe_column, {
        key: 9,
        fixed: item.fixed,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row[item.field],
          "onUpdate:modelValue": $event => row[item.field] = $event,
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 2
      }, 1032, ["fixed", "field", "title", "width", "align"])), [[_directive_allow, 'NewCost.NewCostFinance']]) : _createCommentVNode("", true), item.type == 'colfdedit-allow-price' ? _withDirectives((_openBlock(), _createBlock(_component_vxe_column, {
        key: 10,
        fixed: item.fixed,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(scope => [_createVNode(_component_vxe_input, {
          modelValue: scope.row[item.field],
          "onUpdate:modelValue": $event => scope.row[item.field] = $event,
          type: "text",
          disabled: item.dislist[scope.$rowIndex],
          onChange: $event => _ctx.getDom.updateStatus(scope)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])]),
        _: 2
      }, 1032, ["fixed", "field", "title", "width", "align"])), [[_directive_allow, 'NewCost.NewCostFinance']]) : _createCommentVNode("", true), item.type == 'cboxq' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 11,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "edit-render": {}
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(_ctx.getShowbox(row[item.field])), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_checkbox, {
          modelValue: row[item.field],
          "onUpdate:modelValue": $event => row[item.field] = $event,
          content: ""
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'cboxq_1' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 12,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "edit-render": {}
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(_ctx.getShowbox(row[item.field])), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_checkbox, {
          modelValue: row[item.field],
          "onUpdate:modelValue": $event => row[item.field] = $event,
          content: ""
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'switch' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 13,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "edit-render": {}
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(_ctx.getShowSwitch(row[item.field])), 1)]),
        edit: _withCtx(scope => [_createVNode(_component_vxe_switch, {
          modelValue: scope.row[item.field],
          "onUpdate:modelValue": $event => scope.row[item.field] = $event,
          "open-label": "开",
          "close-label": "关",
          "open-value": 1,
          "close-value": 0,
          class: "my-switch2"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'selout' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 14,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "edit-render": {}
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(_ctx.getShowName(row[item.field], item.list)), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_select, {
          modelValue: row[item.field],
          "onUpdate:modelValue": $event => row[item.field] = $event,
          transfer: "",
          onChange: $event => _ctx.changeMethods(row, row[item.field], item.field)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, it => {
            return _openBlock(), _createBlock(_component_vxe_option, {
              key: it.id,
              value: it.id,
              label: it.name
            }, null, 8, ["value", "label"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'selout_1' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 15,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "edit-render": {}
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(_ctx.getShowName(row[item.field], item.list)), 1)]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_select, {
          modelValue: row[item.field],
          "onUpdate:modelValue": $event => row[item.field] = $event,
          transfer: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, it => {
            return _openBlock(), _createBlock(_component_vxe_option, {
              key: it.id,
              value: it.id,
              label: it.name
            }, null, 8, ["value", "label"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'selmhout' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 16,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "edit-render": {}
      }, {
        default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.getShowMhName(scope.row[item.field], item.list[scope.$rowIndex], scope.$rowIndex)), 1)]),
        edit: _withCtx(scope => [_createVNode(_component_el_select, {
          modelValue: scope.row[item.field],
          "onUpdate:modelValue": $event => scope.row[item.field] = $event,
          filterable: "",
          remote: "",
          disabled: item.dislist[scope.$rowIndex],
          "reserve-keyword": "",
          "remote-method": query => {
            _ctx.getComList(query, scope.$rowIndex, scope);
          },
          "popper-append-to-body": false,
          placeholder: "可搜索"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list[scope.$rowIndex], (it, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: it.name,
              value: it.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "remote-method"])]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'selmhout-allow' ? _withDirectives((_openBlock(), _createBlock(_component_vxe_column, {
        key: 17,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align,
        "edit-render": {}
      }, {
        default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.getShowMhName(scope.row[item.field], item.list[scope.$rowIndex], scope.$rowIndex)), 1)]),
        edit: _withCtx(scope => [_createVNode(_component_el_select, {
          modelValue: scope.row[item.field],
          "onUpdate:modelValue": $event => scope.row[item.field] = $event,
          filterable: "",
          remote: "",
          disabled: item.dislist[scope.$rowIndex],
          "reserve-keyword": "",
          "remote-method": query => {
            _ctx.getComList(query, scope.$rowIndex, scope);
          },
          "popper-append-to-body": false,
          placeholder: "可搜索"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list[scope.$rowIndex], (it, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: it.name,
              value: it.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "remote-method"])]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])), [[_directive_allow, 'NewCost.NewCostFinance']]) : _createCommentVNode("", true), item.type == 'imgupload' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 18,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align
      }, {
        default: _withCtx(({
          row
        }) => [_createVNode(_component_el_upload, {
          action: _ctx.data.upLoadUrl,
          "with-credentials": true,
          "on-success": function (res, file, file_list) {
            return _ctx.handleSuccess(res, file, file_list, row);
          },
          "show-file-list": false,
          name: "file",
          limit: 1,
          data: _ctx.data.upLoadQuery,
          accept: ".png, .jpg",
          "on-change": _ctx.handleChange
        }, {
          default: _withCtx(() => [row.image ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.data.cdn + row.image,
            class: "avatar",
            onMousemove: $event => _ctx.entryCellShowImg($event, row),
            onMouseout: $event => _ctx.leaveCellBlurImg(row)
          }, null, 40, _hoisted_3)) : (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            class: "el-icon-plus"
          })), _ctx.data.showImgUrl ? _withDirectives((_openBlock(), _createElementBlock("view", {
            key: 2,
            class: "img-show position-f",
            style: _normalizeStyle(_ctx.data.top)
          }, [_createElementVNode("img", {
            src: _ctx.data.cdn + _ctx.data.showImgUrl
          }, null, 8, _hoisted_4)], 4)), [[_vShow, row.showImg]]) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["action", "on-success", "data", "on-change"])]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true)]);
    }), 128))]),
    _: 1
  }, 8, ["data", "edit-rules", "onCheckboxChange", "onCheckboxAll", "row-class-name"]), _createVNode(_component_BatchEdit, {
    isBatchEditShow: _ctx.data.isBatchEditShow,
    "onUpdate:isBatchEditShow": _cache[1] || (_cache[1] = $event => _ctx.data.isBatchEditShow = $event),
    attrlist: _ctx.data.muleditAttr,
    "onUpdate:attrlist": _cache[2] || (_cache[2] = $event => _ctx.data.muleditAttr = $event),
    onGetBatchEditObj: _ctx.getBatchEditObj
  }, null, 8, ["isBatchEditShow", "attrlist", "onGetBatchEditObj"])]);
}